import { Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

const Title = styled(Typography)`
  opacity: 0.5;
`

const HelperTitle = () => {
  const { t } = useTranslation()
  return (
    <Title variant={'h3'} sx={{ pt: '0.25rem' }}>
      {t('common.label.pleaseSelectDay')}
    </Title>
  )
}

export { HelperTitle }
